module.exports = __webpack_public_path__ + "front/img/44.ac07f34a.jpg";